(function () {
  if (window.JmpusWishlist) return;

  var STORAGE_KEY = 'jmpus:wishlist';
  var EVENT_NAME = 'wishlist:change';
  var HEART_ICON_MARKUP =
    '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-heart" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 5.24 8.515 3.773a4.433 4.433 0 0 0-6.21 0 4.293 4.293 0 0 0 0 6.128L10 17.495l7.695-7.593a4.293 4.293 0 0 0 0-6.128 4.433 4.433 0 0 0-6.21 0zm.765-2.177c2.113-2.084 5.538-2.084 7.65 0a5.29 5.29 0 0 1 0 7.55l-7.695 7.593a1.03 1.03 0 0 1-1.44 0l-7.696-7.594a5.29 5.29 0 0 1 0-7.549C3.697.98 7.122.98 9.234 3.063l.766.755z"/></svg>';

  function readAll() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function writeAll(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // localStorage unavailable (private browsing, quota) — wishlist just won't persist.
    }
  }

  function has(id) {
    return readAll().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  var liveRegion;
  function announce(added) {
    var strings = window.wishlistStrings || {};
    var message = added ? strings.added : strings.removed;
    if (!message) return;
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('role', 'status');
      liveRegion.className = 'visually-hidden';
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = message;
  }

  function toggle(product) {
    if (!product || product.id == null) return false;
    var items = readAll();
    var index = items.findIndex(function (item) {
      return String(item.id) === String(product.id);
    });
    var added;
    if (index > -1) {
      items.splice(index, 1);
      added = false;
    } else {
      items.unshift(product);
      added = true;
    }
    writeAll(items);
    announce(added);
    document.dispatchEvent(
      new CustomEvent(EVENT_NAME, { detail: { id: product.id, added: added, count: items.length } })
    );
    return added;
  }

  function remove(id) {
    var items = readAll().filter(function (item) {
      return String(item.id) !== String(id);
    });
    writeAll(items);
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { id: id, added: false, count: items.length } }));
  }

  function count() {
    return readAll().length;
  }

  window.JmpusWishlist = {
    readAll: readAll,
    has: has,
    toggle: toggle,
    remove: remove,
    count: count,
    EVENT_NAME: EVENT_NAME,
    STORAGE_KEY: STORAGE_KEY,
    HEART_ICON_MARKUP: HEART_ICON_MARKUP,
  };

  function updateIconBubbles() {
    var total = count();
    var strings = window.wishlistStrings || {};
    var template = total === 1 ? strings.countOne : strings.countOther;
    var label = template ? template.replace('[count]', total) : '';

    document.querySelectorAll('[data-wishlist-icon]').forEach(function (wrapper) {
      wrapper.classList.toggle('header__icon--wishlist-has-items', total > 0);
      var bubble = wrapper.querySelector('[data-wishlist-count]');
      if (bubble) bubble.hidden = total === 0;
      var number = wrapper.querySelector('[data-wishlist-count-number]');
      if (number) number.textContent = total > 99 ? '99+' : String(total);
      var labelEl = wrapper.querySelector('[data-wishlist-count-label]');
      if (labelEl && label) labelEl.textContent = label;
    });
  }

  document.addEventListener(EVENT_NAME, updateIconBubbles);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateIconBubbles);
  } else {
    updateIconBubbles();
  }

  function buildToggleButton(labelAdd, labelRemove) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'wishlist-button__toggle';
    button.setAttribute('aria-pressed', 'false');
    if (labelAdd) button.dataset.labelAdd = labelAdd;
    if (labelRemove) button.dataset.labelRemove = labelRemove;
    var iconWrap = document.createElement('span');
    iconWrap.className = 'wishlist-button__icon-wrap';
    iconWrap.innerHTML = HEART_ICON_MARKUP;
    button.appendChild(iconWrap);
    return button;
  }

  if (!customElements.get('wishlist-button')) {
    customElements.define(
      'wishlist-button',
      /** @extends HTMLElement */
      class WishlistButton extends HTMLElement {
        connectedCallback() {
          if (this.dataset.wishlistReady) return;
          this.dataset.wishlistReady = 'true';

          this.product = this.readProduct();
          if (!this.product) return;

          this.button = this.querySelector('button.wishlist-button__toggle');
          if (!this.button) {
            var strings = window.wishlistStrings || {};
            var productTitle = this.product.title || '';
            var labelAdd = strings.add ? strings.add.replace('[product]', productTitle) : null;
            var labelRemove = strings.remove ? strings.remove.replace('[product]', productTitle) : null;
            this.button = buildToggleButton(labelAdd, labelRemove);
            this.appendChild(this.button);
          }

          this.render();
          this.button.addEventListener('click', this.onClick.bind(this));
          this.onChange = this.onChange.bind(this);
          document.addEventListener(EVENT_NAME, this.onChange);
        }

        disconnectedCallback() {
          document.removeEventListener(EVENT_NAME, this.onChange);
        }

        readProduct() {
          var embedded = this.querySelector('[data-wishlist-product]');
          if (embedded) {
            try {
              return JSON.parse(embedded.textContent);
            } catch (error) {
              return null;
            }
          }
          if (this.dataset.product) {
            try {
              return JSON.parse(this.dataset.product);
            } catch (error) {
              return null;
            }
          }
          return null;
        }

        onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          toggle(this.product);
        }

        onChange(event) {
          if (String(event.detail.id) === String(this.product.id)) this.render();
        }

        render() {
          var active = has(this.product.id);
          this.classList.toggle('wishlist-button--active', active);
          this.button.classList.toggle('wishlist-button__toggle--active', active);
          this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
          var label = active ? this.button.dataset.labelRemove : this.button.dataset.labelAdd;
          if (label) this.button.setAttribute('aria-label', label);
        }
      }
    );
  }

  if (!customElements.get('wishlist-page')) {
    customElements.define(
      'wishlist-page',
      /** @extends HTMLElement */
      class WishlistPage extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector('[data-wishlist-grid]');
          this.emptyState = this.querySelector('[data-wishlist-empty]');
          this.renderToken = 0;
          this.onChange = this.render.bind(this);
          document.addEventListener(EVENT_NAME, this.onChange);
          this.render();
        }

        disconnectedCallback() {
          document.removeEventListener(EVENT_NAME, this.onChange);
        }

        render() {
          if (!this.grid) return;
          var items = readAll();
          var token = ++this.renderToken;

          this.grid.hidden = items.length === 0;
          if (this.emptyState) this.emptyState.hidden = items.length > 0;
          this.classList.toggle('wishlist-page--empty', items.length === 0);

          if (items.length === 0) {
            this.grid.innerHTML = '';
            return;
          }

          var grid = this.grid;
          Promise.all(items.map(this.buildCard)).then(function (nodes) {
            if (token !== this.renderToken) return; // a newer render already started
            grid.innerHTML = '';
            nodes.forEach(function (node) {
              grid.appendChild(node);
            });
          }.bind(this));
        }

        // Prefers the real, always-current card fetched from the product's own
        // page (see product-card-client.js `fetchRealCard`); falls back to the
        // hand-built approximation only if that fetch fails (offline, etc.).
        buildCard(item) {
          var fallback = function () {
            return window.JmpusProductCard.buildListItem(item, { showWishlist: true });
          };
          if (!window.JmpusProductCard || !window.JmpusProductCard.fetchRealCard) {
            return Promise.resolve(fallback());
          }
          return window.JmpusProductCard.fetchRealCard(item.url).then(function (node) {
            if (!node) return fallback();
            var li = document.createElement('li');
            li.className = 'grid__item';
            li.appendChild(node);
            return li;
          });
        }
      }
    );
  }
})();
